/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react";

import { NavigateFunction, useNavigate, useParams } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import { styled, SxProps, Theme, useTheme } from "@mui/material/styles";
import { SelectChangeEvent } from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import {
    TRAINING_TYPE_CURRICULUM,
    CURRICULUM_STATUS_APPLYING_ATTEND,
    CURRICULUM_STATUS_DOING,
    CURRICULUM_STATUS_CANCEL_LEARN,
    CURRICULUM_STATUS_COMPLETED,
    CURRICULUM_STATUS_INVALID,
    CURRICULUM_STATUS_NOT_LEARNED,
    HEIGHT_MOBILE_FOOTER,
} from "../../Constants";

import Thumbnail from "../../images/curriculum.png";
import { useScreenSize, ZINDEX_FOOTER } from "../../component/Theme";
import BaseFrame from "../../component/wrapper/BaseFrame";
import ItemizeGroupTag from "../../component/tag/ItemizeGroupTag";
import ItemizeCareerTypeTag from "../../component/tag/ItemizeCareerTypeTag";
import { HomeLink } from "../../component/breadcrums/Links";
import NoData from "../../component/NoData";
import SompoCardBadge from "../../component/card/SompoCardBadge";
import SompoLoading from "../../component/loading/SompoLoading";
import { ApproverSelect, ApproverSelectionContainer, DEFAULT_APPROVER, DUMMY_APPROVERS } from "../../component/approver/ApproverSelection";

import ApplyService from "../../logic/api/ApplyService";
import CurriculumInfoStudentHistoryService, {
    CurriculumInfo,
    CurriculumHistoryItemOnGoing,
    CurriculumHistoryItemResult,
    SubCareers,
    SubCareer,
    AproverOptionItemCancel,
    CategoryItem,
    CareerHistories,
    CareerHistory,
} from "../../logic/api/CurriculumInfoStudentHistoryService";
import CancelService from "../../logic/api/ReqCancelService";
import SaveStCancelService from "../../logic/api/SaveStCancelService";
import SompoContext from "../../logic/context/SompoContext";
import { EPOCH_DATETIME, formatPeriod, offsetDateTimeValueToPeriod } from "../../logic/datetime";
import { openConfirmationDialog, showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import { replaceSubcareersStatus } from "../../logic/utility/replaceLabels";
import { asc, chainedSort, desc } from "../../logic/utility/sort";
import { findLatestHistory } from "../../logic/utility/TrainingUtil";
import { ERROR_MESSAGE_APPROVER1, ERROR_MESSAGE_APPROVER2, MESSAGE_CHECK_APPROVER, MESSAGE_CHECK_APPROVER1, MESSAGE_CHECK_APPROVER2 } from "../training/detail/TrainingDetail";

/* ====================================
 * Logics
 * ==================================== */
const curriculumService = new CurriculumInfoStudentHistoryService();
const applyService = new ApplyService();
const cancelService = new CancelService();
const saveStCancelService = new SaveStCancelService();

const DUMMY_DATA = {
    careerId: "",
    curriculum: {} as CurriculumInfo,
    histories: [],
    subCareers: {
        required: [],
        optional: [],
    },
    category: {} as CategoryItem,
    appliable: true,
    approvers1: DUMMY_APPROVERS,
    approvers2: DUMMY_APPROVERS,
    navigator: () => { },
} as CurriculumDetailData;

const STUDY_ORDER_UNDEFINED = Number.MAX_VALUE;

const setupSubCareers = (
    subCareers: SubCareers,
    careerHistories: CareerHistories[]
): { required: SubCareerCurriculumDetail[]; optional: SubCareerCurriculumDetail[] } => {
    // 整形用の内部関数
    const setup = (_subCareers: SubCareer[], _histories: Map<string, CareerHistory>): SubCareerCurriculumDetail[] =>
        (_subCareers || [])
            .map((subCareer) => {
                // 必要なモノを抜き出し
                const { careerId, studyOrder } = subCareer;

                // 最新履歴を取得
                const { onGoing, result } = _histories.get(careerId) || { onGoing: [], result: [] };
                const latestHistory = findLatestHistory(onGoing, result);

                // #19063: findLatestHistory()の中でステータスを参照していろいろやっていそうなのでここで差し替え
                if (latestHistory?.status) {
                    latestHistory.status = replaceSubcareersStatus(latestHistory.status);
                }

                // 整形
                return {
                    ...subCareer,
                    studyOrder: studyOrder ? parseInt(studyOrder, 10) : STUDY_ORDER_UNDEFINED,
                    status: (latestHistory || {}).status,
                } as SubCareerCurriculumDetail;
            })
            .sort((a, b) =>
                chainedSort(
                    a,
                    b,
                    (_a, _b) => asc(_a.careerTypeId, _b.careerTypeId), // 1. 研修種別(eラーニング、集合研修)
                    (_a, _b) => asc(_a.studyOrder, _b.studyOrder), // 2. 受講順 ※eラーニング用の第2キー
                    (_a, _b) => asc(_a.careerName, _b.careerName) // 3. 講座名 ※受講順の無いeラーニング、集合研修
                )
            );

    // 整形
    const { required, optional } = subCareers; // ぶら下がる講座
    const histories = new Map<string, CareerHistory>(); // 講座の受講履歴
    careerHistories.forEach((career) => {
        const { careerId, histories: careerHistory } = career;
        histories.set(careerId, careerHistory);
    });
    return {
        required: setup(required, histories),
        optional: setup(optional, histories),
    };
};

const fetchCurriculum = async (curriculumId: string): Promise<Partial<CurriculumDetailData>> => {
    // マスタデータ・受講履歴をfetch
    const { curriculumInfoData, appliable, careers, categories, approvers, histories, careerHistories } = await curriculumService.fetch({
        curriculumId,
    });

    /* ========================
     * カリキュラム
     * ======================== */
    // 受講履歴
    const { onGoing, result } = histories;
    const curriculumHistories = [
        // 実施中: 取得順
        ...(onGoing || []),
        // 実績: 修了日時(降順)
        ...(result || []).sort((a, b) => {
            const _get = (h: CurriculumHistory) => h.complDate || EPOCH_DATETIME;
            return desc(_get(a), _get(b));
        }),
    ];

    // 結果データに整形
    // カテゴリ: レスポンスの最上位の最初の分類を表示する
    const mainCategory = (categories || []).find(() => true);

    // 承認者
    const { apply, cancel } = approvers;
    let approvers1: ApproverSelect = DUMMY_APPROVERS;
    let approvers2: ApproverSelect = DUMMY_APPROVERS;
    if (appliable && !curriculumHistories.length) {
        // 受講申請可能
        const { approverList1, approverList2 } = apply;
        approvers1 = {
            approver: (approverList1 && approverList1.length > 0) ? approverList1[0] : DEFAULT_APPROVER,
            approverList: approverList1 || [],
        };
        approvers2 = {
            approver: (approverList2 && approverList2.length > 0) ? approverList2[0] : DEFAULT_APPROVER,
            approverList: approverList2 || [],
        };
    } else if (curriculumHistories.length && curriculumHistories[0].lecCancelOkFlg) {
        // 受講取消可能: プロパティ名を揃えるために別オブジェクトに転記
        const { approverList1, approverList2 } = cancel;
        const adjust = (_approvers: AproverOptionItemCancel[]) =>
            (_approvers || []).map((_approver) => ({
                id: _approver.userId,
                name: _approver.approverOptionString,
            }));
        const adjustedApproverList1 = adjust(approverList1);
        const adjustedApproverList2 = adjust(approverList2);
        approvers1 = {
            approver: (adjustedApproverList1 && adjustedApproverList1.length > 0) ? adjustedApproverList1[0] : DEFAULT_APPROVER,
            approverList: adjustedApproverList1,
        };
        approvers2 = {
            approver: (adjustedApproverList2 && adjustedApproverList2.length > 0) ? adjustedApproverList2[0] : DEFAULT_APPROVER,
            approverList: adjustedApproverList2,
        };
    }

    /* ========================
     * ぶら下がる講座
     * ======================== */
    // データ整形
    const _subCareers = setupSubCareers(careers, careerHistories);

    // 結果データ
    return {
        careerId: curriculumId,
        curriculum: curriculumInfoData.curriculumInfo,
        histories: curriculumHistories,
        subCareers: _subCareers,
        category: mainCategory,
        appliable,
        approvers1,
        approvers2,
    };
};

const apply = (data: CurriculumDetailData) => {
    const _fetch = async () => {
        try {
            const { careerId, approvers1, approvers2 } = data;
            await applyService.apply(
                {
                    careerType: TRAINING_TYPE_CURRICULUM,
                    applies: [
                        {
                            careerId,
                            approverId1: approvers1.approver?.id,
                            approverId2: approvers2.approver?.id,
                        },
                    ],
                },
                () => {
                    navigateToApplication(data);
                },
                (error: unknown) => {
                    throw error;
                }
            );
        } catch (error: unknown) {
            console.error(error);
            const { message } = error as any;
            if (ApplyService.isCapacityOverError(message)) {
                showErrorMessage({ message, error });
            } else if((message || "").includes(MESSAGE_CHECK_APPROVER1) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                //1段階承認を承認できる方が設定されていないため申請できません。
                showErrorMessage({ message: ERROR_MESSAGE_APPROVER1, error });
            } else if((message || "").includes(MESSAGE_CHECK_APPROVER2) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                //2段階承認を承認できる方が設定されていないため申請できません。
                showErrorMessage({ message: ERROR_MESSAGE_APPROVER2, error });
            } else {
                showErrorMessage({ message: "受講申請に失敗しました。", error });
            }
        }
    };
    void _fetch();
};

const cancel = (data: CurriculumDetailData) => {
    const _fetch = async () => {
        try {
            const { careerId } = data;
            await cancelService.cancelApplicationCurriculum(
                {
                    careerId,
                },
                () => {
                    navigateToCancel(data);
                },
                (error: unknown) => {
                    throw error;
                }
            );
        } catch (error: unknown) {
            console.error(error);
            showErrorMessage({ message: "取消申請に失敗しました。", error });
        }
    };
    void _fetch();
};

// 受講取消申請の実施
const cancelAttend = (data: CurriculumDetailData) => {
    const _cancel = () => {
        const _fetch = async () => {
            try {
                const { careerId, approvers1, approvers2 } = data;
                await saveStCancelService.cancelAttendCurriculum(
                    {
                        careerId,
                        acceptManagerUserId: approvers1.approver?.id,
                        acceptManagerUserId2: approvers2.approver?.id,
                    },
                    () => {
                        navigateToCancelAttend(data);
                    },
                    (error: unknown) => {
                        throw error;
                    }
                );
            } catch (error: unknown) {
                console.error(error);
                const { message } = error as any;
                if((message || "").includes(MESSAGE_CHECK_APPROVER1) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                    //1段階承認を承認できる方が設定されていないため申請できません。
                    showErrorMessage({ message: ERROR_MESSAGE_APPROVER1, error });
                } else if((message || "").includes(MESSAGE_CHECK_APPROVER2) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                    //2段階承認を承認できる方が設定されていないため申請できません。
                    showErrorMessage({ message: ERROR_MESSAGE_APPROVER2, error });
                } else {
                    showErrorMessage({ message: "受講取消申請に失敗しました。", error });
                }
            }
        };
        void _fetch();
    };

    openConfirmationDialog({
        message: "受講を取り消しますか？",
        resolve: _cancel,
    });
};
const navigate = (navigator: NavigateFunction, path: string, state?: object) => navigator(path, { state });
const navigateToApplication = (data: CurriculumDetailData) =>
    navigate(data.navigator, `/curriculum/application/${data.careerId}`, { curriculum: data.curriculum });
const navigateToCancel = (data: CurriculumDetailData) =>
    navigate(data.navigator, `/curriculum/cancel/${data.careerId}`, { curriculum: data.curriculum });
const navigateToCancelAttend = (data: CurriculumDetailData) =>
    navigate(data.navigator, `/curriculum/cancelAttend/${data.careerId}`, { curriculum: data.curriculum });
const navigateToTrainingDetail = (navigator: NavigateFunction, careerId: string) => () => navigate(navigator, `/training/detail/${careerId}`);

/* ====================================
 * Interfaces/Types
 * ==================================== */
interface CurriculumHistory extends CurriculumHistoryItemOnGoing, CurriculumHistoryItemResult { }
interface SubCareerCurriculumDetail extends Omit<SubCareer, "studyOrder"> {
    status?: string;
    studyOrder: number;
}

/**
 * 画面表示用のデータ。<br/>
 * 以下を含む。
 *   ・カリキュラムID(CU～)
 *   ・カリキュラム情報
 *   ・このカリキュラムにぶら下がる研修(必須/選択)
 *   ・このカリキュラムがぶら下がる分類(=カテゴリ)
 *   ・申請時の承認者情報
 *
 * @interface
 * @property {string} careerId カリキュラムID
 * @property {CurriculumInfo} curriculum カリキュラムのマスタデータ
 * @property {Array<CurriculumHistory>} histories カリキュラムの受講履歴(実施中・実績)
 * @property  subCareers ぶら下がる講座(研修)
 * @property {Array<SubCareerCurriculumDetail>} subCareers.required 必須の研修
 * @property {Array<SubCareerCurriculumDetail>} subCareers.optional 選択の研修
 * @property {CategoryItem | undefined} category このカリキュラムが所属する分類
 * @property {boolean} appliable このカリキュラムへの受講申請可否(true: 受講申請可、false: 受講申請不可)
 * @property {ApproverSelect} approvers1 受講・取消申請の1段階承認者設定
 * @property {ApproverSelect} approvers2 受講・取消申請の2段階承認者設定
 * @property {ApproverSelect} navigator React-RouterのNavigateFunction: 画面遷移に使用
 */
interface CurriculumDetailData {
    careerId: string;
    curriculum: CurriculumInfo;
    histories: Array<CurriculumHistory>;
    subCareers: {
        required: Array<SubCareerCurriculumDetail>;
        optional: Array<SubCareerCurriculumDetail>;
    };
    category: CategoryItem | undefined;
    appliable: boolean;
    approvers1: ApproverSelect;
    approvers2: ApproverSelect;
    navigator: NavigateFunction;
}

// 承認者選択用のイベントハンドラを作成
const createHandleChangeApprover = (curriculum: CurriculumDetailData, setCurriculum: React.Dispatch<React.SetStateAction<CurriculumDetailData>>) => {
    // 第1承認者
    const handleChangeApprover1 = (event: SelectChangeEvent) => {
        const newApprover = (curriculum.approvers1.approverList || []).find((e) => e.id === event.target.value);
        if (!newApprover) return;
        setCurriculum({
            ...curriculum,
            approvers1: {
                ...curriculum.approvers1,
                approver: newApprover,
            },
        });
    };
    // 第2承認者
    const handleChangeApprover2 = (event: SelectChangeEvent) => {
        const newApprover = (curriculum.approvers2.approverList || []).find((e) => e.id === event.target.value);
        if (!newApprover) return;
        setCurriculum({
            ...curriculum,
            approvers2: {
                ...curriculum.approvers2,
                approver: newApprover,
            },
        });
    };
    return [handleChangeApprover1, handleChangeApprover2];
};

/**
 * 基本情報エリアに表示するメッセージ・ボタンを決定する。
 * @returns { message: メッセージ, button: ボタン }
 */
const getInformation = (
    curriculum: CurriculumDetailData,
    setCurriculum: React.Dispatch<React.SetStateAction<CurriculumDetailData>>
): { message: React.ReactNode; button: React.ReactNode; approver: React.ReactNode } => {
    let message: React.ReactNode = "";
    let button: React.ReactNode = <></>;
    let approver: React.ReactNode = <></>;

    // 承認者選択用のイベントハンドラを取得
    const [handleChangeApprover1, handleChangeApprover2] = createHandleChangeApprover(curriculum, setCurriculum);

    // 最新の履歴で分岐
    const latestHistory = curriculum.histories[0];
    if (latestHistory) {
        // 受講中・実績の場合：ステータスで分岐
        switch (latestHistory.statusId) {
            // 受講申請中：キャンセルボタン
            case CURRICULUM_STATUS_APPLYING_ATTEND:
                message = "※受講申請中です。回答までしばらくお待ちください。";
                button = latestHistory.appCancelOkFlg && <CancelButton {...curriculum} />;
                break;

            // 受講中：ボタンなし
            case CURRICULUM_STATUS_DOING:
                message = "※受講中です。";
                break;

            // 受講取消：ボタンなし
            case CURRICULUM_STATUS_CANCEL_LEARN:
                message = "※受講取消済みです。";
                break;

            // 修了：ボタンなし
            case CURRICULUM_STATUS_COMPLETED:
                message = (
                    <>
                        <Grid container direction="row" alignItems="center">
                            <CheckCircleIcon sx={{ color: "#27AB0C" }} />
                            <Typography sx={{ color: "#000" }}>{"修了しています。"}</Typography>
                        </Grid>
                    </>
                );
                break;

            // 失効：ボタンなし
            case CURRICULUM_STATUS_INVALID:
                message = "※失効しています。";
                break;

            // 未受講：ボタンなし
            case CURRICULUM_STATUS_NOT_LEARNED:
                message = "※未受講です。";
                break;

            // それ以外のステータス：API仕様上定義なし、何も表示しない
            default:
                break;
        }
    } else {
        // 履歴なしの場合
        if (!curriculum.appliable) {
            // 受講申請が不可能の場合はボタンを非表示
            message = "※本カリキュラムは受講申請できません。";
        } else {
            // 受講申請が可能の場合は承認者選択とボタンを表示
            message = "※受講申請してください。";
            button = <ApplyButton {...curriculum} />;
            approver = (
                <ApproverSelectionContainer
                    show={true}
                    approver1={curriculum.approvers1.approver}
                    approverList1={curriculum.approvers1.approverList}
                    handleChangeApprover1={handleChangeApprover1}
                    approver2={curriculum.approvers2.approver}
                    approverList2={curriculum.approvers2.approverList}
                    handleChangeApprover2={handleChangeApprover2}
                />
            );
        }
    }

    return {
        message,
        button,
        approver,
    };
};

/* ====================================
 * Sub components
 * ==================================== */
const Tags = (props: CurriculumDetailData) => (
    <>
        <ItemizeGroupTag>{props.category?.categoryName || ""}</ItemizeGroupTag>
        <ItemizeCareerTypeTag careerTypeId={TRAINING_TYPE_CURRICULUM} />
    </>
);

const Credit = (props: CurriculumDetailData) => (
    <>
        <Typography>{`必要単位数： ${props.curriculum.credit || ""}`}</Typography>
    </>
);

/**
 * 基本情報：サムネイル・メッセージ・ボタン
 *
 * @param curriculum 表示データ
 *
 * @returns 基本情報のReact DOM
 */
const Information = (props: { curriculum: CurriculumDetailData; setCurriculum: React.Dispatch<React.SetStateAction<CurriculumDetailData>> }) => {
    const { desktop } = useScreenSize();
    const { curriculum, setCurriculum } = props;
    return (
        <Grid container alignItems="center" justifyContent="center">
            <Box
                sx={{
                    width: "100%",
                    bgcolor: "white",
                    borderRadius: "5px",
                    pt: 0,
                }}
            >
                {/* サムネイル */}
                <Grid sx={{ position: "relative" }}>
                    <Box
                        component={"img"}
                        className="box_image"
                        src={Thumbnail}
                        sx={{
                            display: "flex",
                            width: "100%",
                            alignItems: "flex-end",
                            borderRadius: "5px",
                            objectFit: "cover",
                            aspectRatio: "16/9",
                        }}
                    />
                    <Grid sx={{ position: "absolute", bottom: "0", right: "0" }}>
                        {<SompoCardBadge division={curriculum.curriculum.division} width="118px" height="98px" variant="h6" />}
                    </Grid>
                </Grid>

                {desktop && <Actions curriculum={curriculum} setCurriculum={setCurriculum} />}
            </Box>
        </Grid>
    );
};

const Actions = (props: { curriculum: CurriculumDetailData; setCurriculum: React.Dispatch<React.SetStateAction<CurriculumDetailData>> }) => {
    const theme = useTheme();
    const { desktop } = useScreenSize();
    const { curriculum, setCurriculum } = props;
    const { approvers1, approvers2 } = curriculum;
    const { message, button, approver } = getInformation(curriculum, setCurriculum);
    const latestHistory = curriculum.histories[0]; // 最新履歴

    // 承認者選択用のイベントハンドラを取得
    const [handleChangeApprover1, handleChangeApprover2] = createHandleChangeApprover(curriculum, setCurriculum);

    return desktop ? (
        <Grid
            item
            sx={{ padding: 2, bgcolor: "white", height: "100%" }}
            container
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            rowSpacing={desktop ? 3 : 0}
            flexWrap={"nowrap"}
        >
            {/* メッセージ */}
            <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%" }}>
                <Typography>{message}</Typography>
            </Grid>

            <Grid item container direction="column" rowSpacing={1}>
                {/* 承認者 */}
                <Grid item sx={{ width: "100%" }}>
                    {approver}
                </Grid>
                {/* ボタン */}
                <Grid item sx={{ width: "100%" }}>
                    {button}
                </Grid>
            </Grid>

            {/* 受講取消が可能な場合のみ承認者選択と受講取消ボタンを表示 */}
            {latestHistory && latestHistory.lecCancelOkFlg && (
                <Grid item sx={{ width: "100%" }}>
                    <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%", mb: 1 }}>
                        <Typography>※受講取消が可能です。</Typography>
                    </Grid>
                    <Grid item sx={{ width: "100%", mb: 1 }}>
                        <ApproverSelectionContainer
                            show={true}
                            approver1={approvers1.approver}
                            approverList1={approvers1.approverList}
                            handleChangeApprover1={handleChangeApprover1}
                            approver2={approvers2.approver}
                            approverList2={approvers2.approverList}
                            handleChangeApprover2={handleChangeApprover2}
                        />
                    </Grid>
                    <CancelAttendButton {...curriculum} />
                </Grid>
            )}
        </Grid>
    ) : (
        // モバイル版はフッタ
        <MobileFooter curriculum={curriculum} setCurriculum={setCurriculum} />
    );
};

/**
 * 申請ボタン
 *
 * @param props 表示データ
 *
 * @returns 申請ボタンのReact DOM
 */
const ApplyButton = (props: CurriculumDetailData) => (
    <>
        <ActionButton
            label={"申請する"}
            onClick={() => {
                apply(props);
            }}
        />
    </>
);

/**
 * キャンセルボタン
 *
 * @param props 表示データ
 *
 * @returns キャンセルボタンのReact DOM
 */
const CancelButton = (props: CurriculumDetailData) => (
    <>
        <ActionButton
            label={"申請をキャンセルする"}
            onClick={() => {
                cancel(props);
            }}
        />
    </>
);

/**
 * 受講取消ボタン
 *
 * @param props 表示データ
 *
 * @returns 受講取消ボタンのReact DOM
 */
const CancelAttendButton = (props: CurriculumDetailData) => {
    const theme = useTheme();
    return (
        <>
            <ActionButton
                label={"受講取消"}
                onClick={() => {
                    cancelAttend(props);
                }}
                sx={{
                    border: "1px solid",
                    borderColor: theme.palette.primary.contrastText,
                    color: theme.palette.primary.contrastText,
                    bgcolor: "#FFF",
                    "&:hover": {
                        bgcolor: "#FFF",
                        opacity: "0.7",
                        cursor: "pointer",
                    },
                }}
            />
        </>
    );
};

const ActionButton = (props: { label: string; onClick: () => void; sx?: SxProps<Theme> }) => {
    const theme = useTheme();
    const { label, onClick, sx } = props;
    return (
        <>
            <Button
                fullWidth
                sx={{
                    color: "white",
                    bgcolor: theme.palette.primary.main,
                    "&:hover": {
                        bgcolor: theme.palette.primary.main,
                        opacity: "0.7",
                        cursor: "pointer",
                    },
                    ...sx,
                }}
                onClick={onClick}
            >
                <Typography>{label}</Typography>
            </Button>
        </>
    );
};

/**
 * 詳細情報：目的・概要・対象者・備考・必須・選択
 *
 * @param props 表示データ
 *
 * @returns 詳細情報のReact DOM
 */
const Detail = (props: CurriculumDetailData) => {
    const { curriculum, subCareers } = props;
    return (
        <>
            <Row key={"CurriculumDetail-Row-1"} name="目的" content={curriculum.purpose} />
            <Row key={"CurriculumDetail-Row-2"} name="概要" content={curriculum.outline} />
            <Row key={"CurriculumDetail-Row-3"} name="対象者" content={curriculum.target} />
            <Row key={"CurriculumDetail-Row-4"} name="備考" content={curriculum.comment} />
            <Row
                key={"CurriculumDetail-Row-5"}
                name={`必須(${subCareers.required.length}件)`}
                content={<SubCareerTable subCareers={subCareers.required} />}
            />
            <Row
                key={"CurriculumDetail-Row-6"}
                name={`選択(${subCareers.optional.length}件)`}
                content={<SubCareerTable subCareers={subCareers.optional} />}
            />
        </>
    );
};

/**
 * カリキュラムにぶら下がる講座のリスト
 *
 * @param props 表示データ
 *
 * @returns カリキュラムにぶら下がる講座のリストのReact DOM
 */
const SubCareerTable = (props: { subCareers: SubCareerCurriculumDetail[] }) => {
    const { desktop, mobile } = useScreenSize();
    const { subCareers = [] } = props;
    const navigator = useNavigate();

    // セルのスタイル
    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            // ヘッダー部分
            backgroundColor: "#CCCCCC",
            textAlign: "center",
        },
        [`&.${tableCellClasses.body}`]: {
            // body部分
            wordBreak: "break-all",
        },
        // 共通部分
        border: "1px solid #999",
        backgroundColor: "#fff",
    }));

    return subCareers.length ? (
        <>
            <TableContainer sx={{ mb: 2, width: "100%", maxHeight: desktop ? "330px" : "480px" }}>
                <Table stickyHeader>
                    {/* head開始 */}
                    <TableHead>
                        <TableRow>
                            <StyledTableCell
                                sx={{
                                    width: desktop ? "285px" : "180px",
                                    ...(mobile && { minWidth: "180px" }),
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "left" }}>
                                    講座名
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                                sx={{
                                    width: "105px",
                                    ...(mobile && { minWidth: "105px" }),
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "left" }}>
                                    ステータス
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                                sx={{
                                    width: "185px",
                                    ...(mobile && { minWidth: "185px" }),
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "left" }}>
                                    実施期間
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                                sx={{
                                    width: "100px",
                                    ...(mobile && { minWidth: "100px" }),
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                    種別
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                                sx={{
                                    width: "80px",
                                    ...(mobile && { minWidth: "80px" }),
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                    単位
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell
                                sx={{
                                    width: "80px",
                                    ...(mobile && { minWidth: "80px" }),
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                    順番
                                </Typography>
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    {/* head終了 */}
                    {/* body開始 */}
                    <TableBody>
                        {subCareers.map((subCareer, index) => (
                            <React.Fragment key={`CurriculumDetail-List-Career-${subCareer.careerId}-${index}`}>
                                <TableRow>
                                    <StyledTableCell onClick={navigateToTrainingDetail(navigator, subCareer.careerId)}>
                                        <Tooltip title={subCareer.careerName}>
                                            <Typography
                                                variant="body1"
                                                className={desktop ? "ellipses2" : ""}
                                                sx={{
                                                    fontWeight: "bold",
                                                    textDecoration: "underline",
                                                    transition: "all 0.2s ease-in-out",
                                                    color: "#29267A",
                                                    "&:hover": {
                                                        opacity: "0.7",
                                                        cursor: "pointer",
                                                    },
                                                }}
                                            >
                                                {subCareer.careerName}
                                            </Typography>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                wordBreak: "keep-all",
                                            }}
                                        >
                                            {subCareer.status || "---"}
                                        </Typography>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Typography variant="body1">
                                            {formatPeriod(offsetDateTimeValueToPeriod(subCareer.careerStartDate, subCareer.careerEndDate))}
                                        </Typography>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Typography variant="body1">{subCareer.careerType}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Typography variant="body1">{`${subCareer.credit || 0}単位`}</Typography>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Typography variant="body1">
                                            {subCareer.studyOrder !== STUDY_ORDER_UNDEFINED ? `${subCareer.studyOrder}番目` : ""}
                                        </Typography>
                                    </StyledTableCell>
                                </TableRow>
                            </React.Fragment>
                        ))}
                    </TableBody>
                    {/* body終了 */}
                </Table>
            </TableContainer>
        </>
    ) : (
        <NoData
            message="表示データがありません"
            boxStyle={{ justifyContent: "flex-start", minHeight: "auto" }}
            typographyStyle={{ fontWeight: "normal" }}
        />
    );
};

/**
 * 詳細情報の1項目
 *
 * @param props name:項目名、content:表示内容
 *
 * @returns 詳細情報の1項目のReact DOM
 */
const Row = (props: { name: string; content: React.ReactNode }) => {
    const { desktop, mobile } = useScreenSize();
    return (
        <Grid container direction={desktop ? "row" : "column"} alignItems="flex-start" columns={20} sx={{ mb: 2 }}>
            <Grid item xs={desktop ? 6 : 20} sm={desktop ? 5 : 20} md={desktop ? 4 : 20}>
                <Typography sx={{ fontWeight: "bold" }}>{props.name}</Typography>
            </Grid>
            <Grid item xs={desktop ? 14 : 20} sm={desktop ? 15 : 20} md={desktop ? 16 : 20} sx={{ ...(mobile && { width: "100%" }) }}>
                {(() => {
                    const { content } = props;
                    if (!content || typeof content === "string") {
                        return ((content as string) || "").split("\n").map((line, index) => {
                            const key = `CurriculumDetail-Row-${props.name}-${index}`;
                            if (line) {
                                return (
                                    <Typography key={key} variant="h6" sx={{ overflowWrap: "break-word" }}>
                                        {line}
                                    </Typography>
                                );
                            }
                            return (
                                <Typography
                                    key={key}
                                    variant="h6"
                                    sx={{ overflowWrap: "break-word" }}
                                    dangerouslySetInnerHTML={{
                                        __html: "&nbsp;",
                                    }}
                                />
                            );
                        });
                    }
                    return content;
                })()}
            </Grid>
        </Grid>
    );
};

const MobileFooter = (props: { curriculum: CurriculumDetailData; setCurriculum: React.Dispatch<React.SetStateAction<CurriculumDetailData>> }) => {
    // Hooks.
    const theme = useTheme();

    // Data.
    const { curriculum, setCurriculum } = props;
    const { approvers1, approvers2 } = curriculum;
    const { message, button, approver } = getInformation(curriculum, setCurriculum);
    const latestHistory = curriculum.histories[0]; // 最新履歴

    // States.
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    // Event handlers.
    const toggleDrawer = (newOpen: boolean) => () => {
        setDrawerOpen(newOpen);
    };

    // 承認者選択用のイベントハンドラを取得
    const [handleChangeApprover1, handleChangeApprover2] = createHandleChangeApprover(curriculum, setCurriculum);

    // Render component.
    return (
        <>
            {/* フッタ本体 */}
            <Box sx={{ bgcolor: "white", height: "100%", width: "100%" }}>
                <Button
                    fullWidth
                    sx={{
                        color: theme.palette.primary.contrastText,
                        bgcolor: "white",
                        py: 0,
                        "&:hover": {
                            bgcolor: "white",
                            opacity: "0.7",
                            cursor: "pointer",
                        },
                        height: "100%",
                    }}
                    onClick={toggleDrawer(true)}
                >
                    <Grid container sx={{ justifyContent: "center", alignItems: "flex-start", height: "100%" }}>
                        <Grid item sx={{ display: "flex", alignItems: "center", height: "70%" }}>
                            <Typography>操作メニュー</Typography>
                            <ExpandLessIcon />
                        </Grid>
                    </Grid>
                </Button>
            </Box>

            {/* ドロワ：初期は非表示 */}
            <Drawer
                anchor="bottom"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    zIndex: ZINDEX_FOOTER,
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    "& .MuiDrawer-root": {
                        height: "100%",
                    },
                    "& .MuiDrawer-paper": {
                        height: "100%",
                    },
                }}
            >
                <Grid item flexShrink={1} sx={{ height: HEIGHT_MOBILE_FOOTER, minHeight: HEIGHT_MOBILE_FOOTER, maxHeight: HEIGHT_MOBILE_FOOTER }}>
                    <Button
                        fullWidth
                        sx={{
                            color: theme.palette.primary.contrastText,
                            bgcolor: "white",
                            py: 0,
                            "&:hover": {
                                bgcolor: "white",
                                opacity: "0.7",
                                cursor: "pointer",
                            },
                            height: "100%",
                        }}
                        onClick={toggleDrawer(false)}
                    >
                        <Grid container sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <Grid item sx={{ display: "flex", alignItems: "center", height: "70%" }}>
                                <Typography>操作メニュー</Typography>
                                <ExpandMoreIcon />
                            </Grid>
                        </Grid>
                    </Button>
                </Grid>
                <Grid
                    item
                    container
                    flexGrow={1}
                    flexDirection={"column"}
                    flexWrap={"nowrap"}
                    sx={{
                        minHeight: `calc(100% - ${HEIGHT_MOBILE_FOOTER})`,
                        maxHeight: `calc(100% - ${HEIGHT_MOBILE_FOOTER})`,
                        overflowX: "hidden",
                        overflowY: "auto",
                    }}
                >
                    <Grid
                        item
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="center"
                        rowSpacing={1}
                        flexWrap={"nowrap"}
                        sx={{
                            padding: 2,
                            bgcolor: "white",
                        }}
                    >
                        {/* メッセージ */}
                        <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%" }}>
                            <Typography>{message}</Typography>
                        </Grid>

                        {/* 承認者 */}
                        <Grid item sx={{ width: "100%" }}>
                            {approver}
                        </Grid>

                        {/* ボタン */}
                        <Grid item sx={{ width: "100%" }}>
                            {button}
                        </Grid>

                        {/* 受講取消が可能な場合のみ承認者選択と受講取消ボタンを表示 */}
                        {latestHistory && latestHistory.lecCancelOkFlg && (
                            <Grid item sx={{ width: "100%" }}>
                                <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%", mb: 1 }}>
                                    <Typography>※受講取消が可能です。</Typography>
                                </Grid>
                                <Grid item sx={{ width: "100%", mb: 1 }}>
                                    <ApproverSelectionContainer
                                        show={true}
                                        approver1={approvers1.approver}
                                        approverList1={approvers1.approverList}
                                        handleChangeApprover1={handleChangeApprover1}
                                        approver2={approvers2.approver}
                                        approverList2={approvers2.approverList}
                                        handleChangeApprover2={handleChangeApprover2}
                                    />
                                </Grid>
                                <CancelAttendButton {...curriculum} />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Drawer>
        </>
    );
};

// Main component.
/**
 * カリキュラム詳細画面
 *
 * @returns カリキュラム詳細画面のReact DOM
 */
const CurriculumDetail = () => {
    // Hooks.
    const { careerId = "" } = useParams();
    const { mobile } = useScreenSize();
    const navigator = useNavigate();

    // States.
    const [curriculum, setCurriculum] = React.useState<CurriculumDetailData>(DUMMY_DATA);

    // Context.
    const sompoContext = React.useContext(SompoContext);

    // Side effects.
    // 初期表示：表示データの読み込み
    React.useEffect(() => {
        const fetch = async () => {
            try {
                sompoContext.setLoading(true);

                // 表示データをfetch
                const _curriculum = await fetchCurriculum(careerId);

                // Set states.
                setCurriculum({
                    ..._curriculum,
                    navigator,
                } as CurriculumDetailData);

                // ローディング表示終了
                sompoContext.setLoading(false);
            } catch (error: unknown) {
                console.error(error);

                // Set states.
                setCurriculum(DUMMY_DATA);
                showErrorMessage({ message: "カリキュラム情報の取得に失敗しました。", error });

                // ローディング表示終了
                sompoContext.setLoading(false);
            }
        };
        void fetch();
    }, []);

    // Main Content.
    const Content = () => (
        <>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Grid item container direction="column" alignItems="flex-start" sx={{ mb: 1 }}>
                    {/* タグ */}
                    <Grid item container direction="row" sx={{ gap: 1, mb: 1 }}>
                        <Tags {...curriculum} />
                    </Grid>

                    {/* 必要単位数 */}
                    <Grid item container direction="row" alignItems="center">
                        <Credit {...curriculum} />
                    </Grid>
                </Grid>
                <Grid item container direction="row" columns={20}>
                    {/* 概要 */}
                    <Grid item xs={20} sm={20} md={5}>
                        <Information curriculum={curriculum} setCurriculum={setCurriculum} />
                    </Grid>

                    {/* 詳細 */}
                    <Grid item xs={20} sm={20} md={15} sx={{ pl: { xs: 0, sm: 0, md: 8 } }}>
                        <Detail {...curriculum} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );

    // Render component.
    return (
        <BaseFrame
            width="80%"
            title={curriculum.curriculum.careerName}
            breadcrumbs={[<HomeLink />]}
            content={sompoContext.loading ? <SompoLoading /> : <Content />}
            footer={mobile && <Actions curriculum={curriculum} setCurriculum={setCurriculum} />}
            // フッター内要素はモバイル用ドロワー展開のボタンのみのためこの高さで固定
            footerHeight={HEIGHT_MOBILE_FOOTER}
        />
    );
};
export default CurriculumDetail;
